import { type ExperimentValue } from '@stone-payments/experiment/src/lib/types'

export enum ProductsOfferDetailsContentEnum {
  ProductName = 'product_name',
  MaturityDate = 'maturity_date',
  MinInvestmentAmount = 'min_investment_amount',
  MaxInvestmentAmount = 'max_investment_amount',
  IrRate = 'ir_rate',
  RedemptionDays = 'redemption_days',
  MaturityDuration = 'maturity_duration',
  YieldValue = 'yield_value',
  RedemptionValue = 'redemption_value',
  IrValue = 'ir_value',
  IrTooltip = 'ir_tooltip',
  TaxationDescription = 'taxation_description'
}

export enum ProductsOfferDetailsItemTypeEnum {
  Issuer = 'issuer',
  Profitability = 'profitability',
  Redemption = 'redemption',
  Maturity = 'maturity',
  MinInvestment = 'min_investment',
  MaxInvestment = 'max_investment',
  Ir = 'ir',
  Unknown = 'unknown'
}

export enum ProductsOfferDetailsStringEnum {
  YieldValueDaily = 'yield_value_daily',
  YieldValueMonthly = 'yield_value_monthly',
  RedemptionValueOnMaturity = 'redemption_value_on_maturity',
  RedemptionValueImmediate = 'redemption_value_immediate',
  RedemptionValueFromDays = 'redemption_value_from_days',
  IrValueRegressive = 'ir_value_regressive',
  IrValueOnMaturity = 'ir_value_on_maturity',
  IrTooltipRegressive = 'ir_tooltip_regressive',
  IrTooltipOnMaturity = 'ir_tooltip_on_maturity',
  TaxationDescriptionCdb = 'taxation_description_cdb',
  TaxationDescriptionRdb = 'taxation_description_rdb'
}

export enum ProductsOfferDetailsAlertIdEnum {
  Taxation = 'taxation'
}

export type ProductsOfferDetailsItemContent = {
  type: string
  label: string
  value: string
  tooltip_text?: string
}

export type ProductsOfferDetailsAlertContent = {
  id: string
  title: string
  description: string
  link_text?: string
}

export type ProductsOfferDetailsContent = {
  title?: string
  items?: ProductsOfferDetailsItemContent[]
  alerts?: ProductsOfferDetailsAlertContent[]
  strings?: Partial<Record<ProductsOfferDetailsStringEnum, string>>
  confirm_button_text?: string
}

export type ProductsOfferDetailsExperimentPayload = ProductsOfferDetailsContent & {
  ignore_default_content?: boolean
}

export const defaultProductsOfferDetailsContent: Required<ProductsOfferDetailsContent> = {
  items: [
    { type: 'issuer', label: 'Emitido por', value: 'Stone SCFI' },
    { type: 'profitability', label: 'Rendimento', value: '{yield_value}' },
    { type: 'redemption', label: 'Resgate', value: '{redemption_value}' },
    { type: 'maturity', label: 'Vencimento', value: '{maturity_date}' },
    { type: 'min_investment', label: 'Investimento mínimo', value: '{min_investment_amount}' },
    { type: 'max_investment', label: 'Investimento máximo', value: '{max_investment_amount}' },
    { type: 'ir', label: 'Imposto de Renda', value: '{ir_value}', tooltip_text: '{ir_tooltip}' }
  ],
  title: '{product_name}',
  alerts: [
    { id: 'taxation', title: 'Sobre tributação', link_text: 'Saiba mais', description: '{taxation_description}' }
  ],
  strings: {
    yield_value_daily: 'Diário',
    ir_value_regressive: 'Regressivo',
    yield_value_monthly: 'Mensal',
    ir_value_on_maturity: '{ir_rate}',
    ir_tooltip_regressive: 'Entre 22,5% e 15%, de acordo com o tempo investido.',
    ir_tooltip_on_maturity: 'Imposto sobre o valor investido no resgate.',
    taxation_description_cdb: 'Esse produto possui incidência de IR e IOF sobre os rendimentos da aplicação',
    taxation_description_rdb: 'Esse produto possui incidência de IR sobre os rendimentos da aplicação',
    redemption_value_from_days: 'A partir de {redemption_days}',
    redemption_value_immediate: 'Imediato',
    redemption_value_on_maturity: 'Após {maturity_duration}'
  },
  confirm_button_text: 'Selecionar'
}

export const defaultProductsOfferDetailsExperimentPayload: ExperimentValue<ProductsOfferDetailsExperimentPayload> = {
  value: 'control',
  payload: { ...defaultProductsOfferDetailsContent, ignore_default_content: false }
}
